/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductFamilyEnum = {
    EsticonProjektant: 'esticon_projektant',
    EsticonZhotovitel: 'esticon_zhotovitel',
    EsticonInvestor: 'esticon_investor',
    Hub: 'hub',
    Mip: 'mip',
    A10: 'A10',
    Ae: 'AE'
} as const;
export type ProductFamilyEnum = typeof ProductFamilyEnum[keyof typeof ProductFamilyEnum];


export function instanceOfProductFamilyEnum(value: any): boolean {
    for (const key in ProductFamilyEnum) {
        if (Object.prototype.hasOwnProperty.call(ProductFamilyEnum, key)) {
            if (ProductFamilyEnum[key as keyof typeof ProductFamilyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductFamilyEnumFromJSON(json: any): ProductFamilyEnum {
    return ProductFamilyEnumFromJSONTyped(json, false);
}

export function ProductFamilyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductFamilyEnum {
    return json as ProductFamilyEnum;
}

export function ProductFamilyEnumToJSON(value?: ProductFamilyEnum | null): any {
    return value as any;
}

export function ProductFamilyEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductFamilyEnum {
    return value as ProductFamilyEnum;
}

